import { apiCap } from "@gik/api";
import { useTaxonomies } from "@gik/api/give/taxonomies";
import { FetchProvider } from "@gik/core/components/DynamicComponent/FetchProvider";
import type { WordpressTaxonomy } from "@gik/core/models/wordpress/WordpressTaxonomy";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import React from "react";
import type { TaxonomyListProps } from ".";
import { TaxonomyList, TaxonomyListSkeleton } from ".";

export type TaxonomyListWithSituationsProps = {
	fallbackData?: WordpressTaxonomy[];
} & TaxonomyListProps;

function TaxonomyListWithSituationsComp(
	props: TaxonomyListWithSituationsProps,
) {
	const { items } = props;

	const useProduct = () => {
		return useTaxonomies(
			"situation",
			{ page: 1, perPage: apiCap },
			{
				fallbackData: items,
			},
		);
	};

	return (
		<FetchProvider
			fetch={useProduct}
			loadingComponent={<TaxonomyListSkeleton {...props} />}
		>
			{({ data }) => <TaxonomyList {...props} items={data} />}
		</FetchProvider>
	);
}

export const TaxonomyListWithSituations = withComponentErrorBoundary(
	TaxonomyListWithSituationsComp,
);
